/**
 * Integrytas Group — ClearFiltersButton (common).
 *
 * The "Clear all filters" control every list-page filter bar must carry (§17.B5):
 * one click resets the free-text search AND every <FacetFilter> at once. Always
 * shown (so it is discoverable), enabled only when at least one filter is active.
 *
 * The page owns the filter state; pass `active` (is anything filtered?) and an
 * `onClear` that resets the search string and all facet arrays.
 */

import { useTranslation } from 'react-i18next';

export interface ClearFiltersButtonProps {
  active: boolean;
  onClear: () => void;
  label?: string;
}

export function ClearFiltersButton({ active, onClear, label }: ClearFiltersButtonProps) {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('common.filters.clear', 'Clear filters');
  return (
    <button
      type="button"
      onClick={onClear}
      disabled={!active}
      title={active ? resolvedLabel : t('common.filters.none_applied', 'No filters applied')}
      className={
        'flex h-8 items-center gap-1 rounded-csm-control border px-2.5 text-csm-sm ' +
        (active
          ? 'border-csm-border bg-white text-csm-ink-soft hover:bg-csm-surface-alt'
          : 'cursor-not-allowed border-csm-border-soft bg-white text-csm-muted opacity-50')
      }
    >
      <span className="text-csm-2xs">✕</span> {resolvedLabel}
    </button>
  );
}
